import './MouOrderForm.css';
import { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import headerImg from '../assets/header.png';
import footerImg from '../assets/footer.png';
import qrImg from '../assets/qr.jpeg';
import FormAside from './FormAside';
import FormNotification from './FormNotification';
import { useLocation } from "react-router-dom";

const mouInlineStyles = `
  .mou-order-form {
    min-height: 100vh;
    padding: 20px;
    background:
      radial-gradient(circle at top, rgba(255, 255, 255, 0.95), rgba(241, 245, 249, 0.9) 35%, rgba(226, 232, 240, 1) 100%);
    color: #0f172a;
    font-family: Arial, Helvetica, sans-serif;
  }

  .mou-print-wrapper {
    width: min(1180px, 100%);
    max-width: 100%;
    margin: 0 auto;
    border-collapse: collapse;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
    border-radius: 18px;
    overflow: hidden;
  }

  .mou-header-img,
  .mou-footer-img {
    display: block;
    width: 100%;
    max-height: 270px;
    object-fit: cover;
  }

  .mou-print-wrapper thead td,
  .mou-print-wrapper tfoot td {
    padding: 0;
  }

  .mou-page {
    padding: 32px 44px 42px;
  }

  .mou-title {
    text-align: center;
    font-size: 1.55rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    margin: 6px 0 18px;
    color: #0f172a;
  }

  .mou-page p,
  .mou-page li {
    line-height: 1.7;
    font-size: 1rem; //did one change
    color: #1e293b;
  }

  .mou-line,
  .mou-stretch-line,
  .mou-line-group,
  .mou-signature-note {
    margin-bottom: 14px;
  }

  .mou-inline-input,
  .mou-order-form input,
  .mou-order-form textarea,
  .mou-order-form select {
    width: 200px;
    max-width: 200px;
    box-sizing: border-box;
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    padding: 10px 12px;
    background: #fff;
    color: #0f172a;
    font-size: 0.95rem;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .mou-inline-input:focus,
  .mou-order-form input:focus,
  .mou-order-form textarea:focus,
  .mou-order-form select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
    background: #fff;
  }

  .mou-inline-input:hover,
  .mou-order-form input:hover,
  .mou-order-form textarea:hover,
  .mou-order-form select:hover,
  .mou-order-form-box:hover,
  .mou-order-form table:hover,
  .mou-order-form td:hover {
    background: #fff !important;
  }

  .mou-order-form textarea {
    min-height: 88px;
    resize: vertical;
  }

  .mou-date-input,
  .mou-city-field {
    max-width: 220px;
  }

  .mou-stretch-field {
    display: inline-block;
    min-width: 220px;
    border-bottom: 2px solid #94a3b8;
  }

  .mou-underline-text {
    display: inline-block;
    min-width: 180px;
    padding: 0 2px 2px;
    border-bottom: 2px solid #94a3b8;
  }

  .mou-filled {
    border-bottom-color: #2563eb;
  }

  .mou-order-form-box {
    margin-top: 24px;
    padding: 46px 52px;
    border-radius: 20px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
    border: 1px solid #e2e8f0;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
  }

  .mou-center {
    text-align: center;
    margin: 0 0 16px;
    color: #0f172a;
  }

  .mou-line-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
    font-weight: 700;
    color: #334155;
  }

  .mou-line-group input,
  .mou-line-group textarea {
    font-weight: 400;
    max-width: 200px;
    justify-self: start;
  }

  .mou-two-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .mou-no-spin::-webkit-outer-spin-button,
  .mou-no-spin::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .mou-add-branch-btn,
  .mou-submit-btn,
  .mou-upload-btn,
  .mou-clear-btn,
  .mou-popup-buttons button,
  .mou-delete-btn {
    border: 0;
    border-radius: 999px;
    padding: 10px 16px;
    font-weight: 700;
    cursor: pointer;
    width:200px;
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  }

  .mou-add-branch-btn:hover,
  .mou-submit-btn:hover,
  .mou-upload-btn:hover,
  .mou-clear-btn:hover,
  .mou-popup-buttons button:hover,
  .mou-delete-btn:hover {
    background: #fff !important;
    color: #111827 !important;
  }

  .mou-add-branch-btn {
    align-self: flex-start;
    background: linear-gradient(135deg, #2563eb, #0f766e);
    color: #fff;
    box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
  }

  .mou-branch-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 12px 0 18px;
  }

  .mou-branch-chip {
    padding: 10px 14px;
    border-radius: 999px;
    background: #e0f2fe;
    color: #075985;
    font-weight: 700;
    cursor: pointer;
  }

  .mou-order-form table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 18px;
  }

  .mou-order-form td {
    padding: 16px 20px;
    border-bottom: 1px solid #e2e8f0;
    vertical-align: top;
  }

  .mou-order-form td:first-child {
    width: 36%;
    font-weight: 700;
    color: #334155;
  }

  .mou-total-amount-input {
    font-weight: 700;
    background: #eff6ff !important;
  }

  .mou-signature-table {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    background: #fff;
    width: 100%;
  }

  .mou-signature-table td {
    width: 50%;
  }

  .mou-signature-note {
    padding: 14px 16px;
    border-left: 4px solid #2563eb;
    background: #eff6ff;
    border-radius: 12px;
    color: #1e3a8a;
    font-weight: 600;
  }

  .mou-signature-row-box {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 8px;
  }

  .mou-signature-canvas {
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    background: #fff;
  }

  .mou-clear-btn {
    background: #e2e8f0;
    color: #0f172a;
  }

  .mou-designation-below-sign {
    margin-top: 8px;
    color: #475569;
    font-size: 0.9rem;
  }

  .mou-payment-section {
    display: grid;
    grid-template-columns: 1.4fr 0.8fr;
    gap: 18px;
    align-items: stretch;
    margin: 20px 0;
  }

  .mou-bank-details,
  .mou-qr-box {
    padding: 18px;
    border-radius: 18px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
  }

  .mou-qr-box {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
  }

  .mou-scan-text {
    font-weight: 800;
    color: #0f172a;
    letter-spacing: 0.08em;
  }

  .mou-qr-image {
    width: min(220px, 100%);
    margin: 0 auto;
    display: block;
    border-radius: 14px;
    border: 1px solid #cbd5e1;
  }

  .mou-upi-text {
    font-weight: 700;
    color: #0f172a;
  }

  .mou-submit-container {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 22px;
  }

  .mou-upload-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e2e8f0;
    color: #0f172a;
    position: relative;
    overflow: hidden;
  }

  .mou-submit-btn {
    background: linear-gradient(135deg, #0f172a, #2563eb);
    color: #fff;
    min-width: 140px;
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.24);
  }

  .mou-uploaded-file-info {
    margin-top: 12px;
    padding: 10px 14px;
    border-radius: 12px;
    background: #ecfeff;
    color: #155e75;
    font-weight: 700;
  }

  .mou-popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.62);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px;
    z-index: 9999;
  }

  .mou-popup-box {
    width: min(560px, 100%);
    max-height: 90vh;
    overflow: auto;
    padding: 22px;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
  }

  .mou-confirm-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: 16px;
  }

  .mou-confirm-item {
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
  }

  .mou-confirm-item span {
    display: block;
    font-size: 12px;
    color: #64748b;
    margin-bottom: 4px;
    font-weight: 700;
  }

  .mou-confirm-item strong {
    display: block;
    color: #0f172a;
    font-size: 14px;
    word-break: break-word;
  }

  .mou-confirm-list {
    margin-top: 14px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #f8fafc;
  }

  .mou-confirm-list h4 {
    margin: 0 0 10px;
    color: #0f172a;
  }

  .mou-confirm-list ul {
    margin: 0;
    padding-left: 18px;
  }

  .mou-confirm-list li {
    margin-bottom: 6px;
    color: #334155;
  }

  .mou-confirm-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 18px;
  }

  .mou-confirm-actions button {
    border: 0;
    border-radius: 999px;
    padding: 10px 16px;
    font-weight: 700;
    cursor: pointer;
  }

  .mou-confirm-cancel {
    background: #e2e8f0;
    color: #0f172a;
  }

  .mou-confirm-submit {
    background: #2563eb;
    color: #fff;
  }

  .mou-popup-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
  }

  .mou-popup-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 16px;
  }

  .mou-popup-buttons button {
    background: #e2e8f0;
    color: #0f172a;
  }

  .mou-delete-btn {
    background: linear-gradient(135deg, #ef4444, #dc2626) !important;
    color: #fff !important;
  }

  .mou-add-branch-btn:hover,
  .mou-submit-btn:hover,
  .mou-upload-btn:hover,
  .mou-clear-btn:hover,
  .mou-popup-buttons button:hover,
  .mou-delete-btn:hover,
  .reports-back-link:hover,
  .reports-logout-btn:hover,
  .reports-tab:hover {
    transform: translateY(-1px);
  }

  .mou-order-form input[type="file"] {
    display: none;
  }

  @media (max-width: 900px) {
    .mou-payment-section {
      grid-template-columns: 1fr;
    }

    .mou-two-fields {
      grid-template-columns: 1fr;
    }

    .mou-page {
      padding: 18px 16px 24px;
    }
  }

  @media (max-width: 720px) {
    .mou-order-form {
      padding: 10px;
    }

    .mou-order-form td {
      display: block;
      width: 100% !important;
      padding-left: 0;
      padding-right: 0;
    }

    .mou-order-form tr {
      display: block;
      margin-bottom: 10px;
    }
  }

  @media print {
    .mou-order-form {
      padding: 0;
      background: #fff;
    }

    .mou-popup-overlay,
    .mou-submit-container,
    .mou-add-branch-btn,
    .mou-clear-btn {
      display: none !important;
    }

    .mou-print-wrapper {
      box-shadow: none;
      border-radius: 0;
    }
  }
`;

export default function MouOrderForm() {

  // // to auto fill the data
  // const location = useLocation();
  // const receivedData = location.state?.followUpData || {};

   const [data, setData] = useState({
    contactPerson: '',
    designation: '',
    schoolName: '',
    address: '',
    phone: '',
    email: '',
    totalAmount: '',
    advanceAmount: '',
    advancePaidDate: "",   // ✅ NEW
    balanceAmount: '',
    balancePaidDate: "",   // ✅ NEW
    executedDate: '',
    city: '',
    state: '',
    strength: '',
    balancePaidDate: "",
    signature: "",
  });

  const [showBranchPopup, setShowBranchPopup] = useState(false);
  const [branchData, setBranchData] = useState({
    branchName: '',
    address: '',
    principalName: '',
    phone: '',
    email: '',
    strength: '',
  });
  const [branches, setBranches] = useState([]);
  const [editingBranchIndex, setEditingBranchIndex] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [showSubmitPreview, setShowSubmitPreview] = useState(false);
  const [plan] = useState('');
  const [moduleCount] = useState('');
  const [paymentType] = useState('');
  const [amountPerStudent] = useState('');
  const signatureUrl = data.signature
    ? `https://cleezoclass.com:8443/${String(data.signature).replace(/^\/+/, '')}`
    : '';

//  To retrive the data by school name
 useEffect(() => {
    if (data.schoolName) {
      getMouDetails();
    }
  }, [data.schoolName]);

   const getMouDetails = async () => {
    try {
      const schoolName = data.schoolName || "";
      console.log("Searching School:", schoolName);
      if (!schoolName) return;
      const response = await axios.get(`https://cleezoclass.com:8443/api/get-mou-details/${encodeURIComponent(schoolName)}`);

      console.log("MOU Retrieved:", response.data);

      if (response.data.success) {
        setData(prev => ({
          ...prev,
          strength: response.data.data.strength || "",
          amountPerStudent: response.data.data.amountPerStudent || "",
          totalAmount: response.data.data.totalAmount || "",
          signature: response.data.data.signature || ""
        }));
      }
    }
    catch (err) { console.log(err); }
  };



  const signatureRef = useRef(null);
  let drawing = false;

  const startDraw = (e) => {
    const canvas = signatureRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    drawing = true;
    ctx.beginPath();
    ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
  };

  const draw = (e) => {
    if (!drawing) return;

    const canvas = signatureRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.lineWidth = 4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#000";

    ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctx.stroke();
  };

  const endDraw = () => {
    drawing = false;
  };

  const clearSignature = () => {
    const canvas = signatureRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;
    if (["strength", "amountPerStudent", "advanceAmount"].includes(name)) {
      newValue = value.replace(/[^0-9.]/g, "");
    }

    setData((prev) => {
      let updatedData = { ...prev, [name]: newValue };

      const strength = parseFloat(updatedData.strength || "0");
      const amountPerStudent = parseFloat(updatedData.amountPerStudent || "0");
      const advanceAmount = parseFloat(updatedData.advanceAmount || "0");

      const totalAmount = strength * amountPerStudent;
      updatedData.totalAmount = (Math.round(totalAmount * 100) / 100).toFixed(2);

      const balance = totalAmount - advanceAmount;
      updatedData.balanceAmount = (Math.round(balance * 100) / 100).toFixed(2);

      return updatedData;
    });
  };
  const handleBranchChange = (e) => {
    setBranchData({ ...branchData, [e.target.name]: e.target.value });
  };

  const handleAddBranch = () => {
    if (!branchData.principalName.trim()) {
      alert('Principal Name is required');
      return;
    }
    if (!branchData.email.trim()) {
      alert('Email is required');
      return;
    }
    if (editingBranchIndex !== null) {
      // UPDATE EXISTING
      const updated = [...branches];
      updated[editingBranchIndex] = branchData;
      setBranches(updated);
    } else {
      // ADD NEW
      setBranches([...branches, branchData]);
    }
    // RESET
    setBranchData({
      branchName: '',
      address: '',
      principalName: '',
      phone: '',
      email: '',
      strength: '',
    });
    setEditingBranchIndex(null);
    setShowBranchPopup(false);
  };

  const handleDeleteBranch = () => {
    if (editingBranchIndex === null) return;
    const updated = branches.filter((_, i) => i !== editingBranchIndex);
    setBranches(updated);
    setEditingBranchIndex(null);
    setShowBranchPopup(false);
    setBranchData({
      branchName: '',
      address: '',
      principalName: '',
      phone: '',
      email: '',
      strength: '',
    });
  };

  const buildPayload = () => {
    const referredBy = localStorage.getItem('empName') || '';

    return {
      ...data,
      branches,
      plan,
      moduleCount,
      paymentType,
      amountPerStudent,
      referredBy,
    };
  };

  const submit = async () => {
    try {
      const payload = buildPayload();
      console.log('[mou-submit] confirm submit clicked');
      console.log('[mou-submit] payload summary:', {
        schoolName: payload.schoolName,
        contactPerson: payload.contactPerson,
        email: payload.email,
        branches: Array.isArray(payload.branches) ? payload.branches.length : 0,
        totalAmount: payload.totalAmount,
      });

      // Submit the form data
      const response = await axios.post('https://cleezoclass.com:8443/api/submit', payload);
      console.log('[mou-submit] response status:', response.status);

      alert('Submitted! A signing link has been sent to your email.');
      setShowSubmitPreview(false);
    } catch (err) {
      console.error(err);
      console.error('[mou-submit] status:', err?.response?.status);
      console.error('[mou-submit] data:', err?.response?.data);
      alert('Failed to submit.');
    }
  };

  const handleOpenSubmitPreview = () => {
    setShowSubmitPreview(true);
  };

  const handleConfirmSubmit = async (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    await submit();
  };

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/png',
    ];
    if (!allowedTypes.includes(file.type)) {
      alert('Only PDF, JPG or PNG allowed');
      return;
    }
    setUploadedFile(file);
  };

  const states = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
  ];

  const cities = {
    "Andhra Pradesh": [
      "Visakhapatnam",
      "Vijayawada",
      "Guntur",
      "Tirupati",
      "Kurnool",
      "Rajahmundry",
      "Kakinada",
      "Nellore",
      "Anantapur",
      "Kadapa",
      "Chittoor",
      "Eluru",
      "Machilipatnam",
      "Ongole",
      "Srikakulam",
      "Vizianagaram",
      "Amaravati",
      "Tenali",
      "Proddatur",
      "Adoni",
      "Hindupur",
      "Gudivada",
      "Bhimavaram",
      "Narasaraopet",
      "Tadepalligudem",
      "Madanapalle",
      "Nandyal",
      "Dharmavaram",
      "Chilakaluripet",
      "Bapatla",
      "Palakollu",
      "Kavali",
      "Rayachoti",
      "Guntakal",
      "Puttur",
      "Sattenapalle",
      "Markapur",
      "Parvathipuram",
      "Tuni",
      "Yemmiganur",
      "Kadiri",
      "Pedana",
      "Repalle",
      "Amalapuram",
      "Tanuku",
      "Sullurpeta",
      "Rajampet",
      "Pithapuram",
      "Samalkot"
    ], "Arunachal Pradesh": ["Itanagar", "Tawang", "Pasighat", "Ziro"],
    "Assam": ["Guwahati", "Dibrugarh", "Jorhat", "Silchar", "Tezpur"],
    "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia"],
    "Chhattisgarh": ["Raipur", "Bilaspur", "Durg", "Korba", "Jagdalpur"],
    "Goa": ["Panaji", "Margao", "Vasco da Gama", "Ponda"],
    "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"],
    "Haryana": ["Chandigarh", "Gurgaon", "Faridabad", "Panipat", "Karnal"],
    "Himachal Pradesh": ["Shimla", "Dharamshala", "Manali", "Mandi"],
    "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro Steel City"],
    "Karnataka": ["Bangalore", "Mysore", "Mangalore", "Hubli", "Belgaum"],
    "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Alappuzha"],
    "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur", "Ujjain"],
    "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane"],
    "Manipur": ["Imphal", "Thoubal", "Bishnupur"],
    "Meghalaya": ["Shillong", "Tura", "Nongpoh"],
    "Mizoram": ["Aizawl", "Lunglei", "Serchhip"],
    "Nagaland": ["Kohima", "Dimapur", "Mokokchung"],
    "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur"],
    "Punjab": ["Chandigarh", "Amritsar", "Ludhiana", "Jalandhar", "Patiala"],
    "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Bikaner", "Ajmer"],
    "Sikkim": ["Gangtok", "Namchi", "Geyzing"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
    "Telangana": [
      "Hyderabad",
      "Warangal",
      "Hanamkonda",
      "Karimnagar",
      "Ramagundam",
      "Khammam",
      "Nizamabad",
      "Mahabubnagar",
      "Suryapet",
      "Miryalaguda",
      "Jagtial",
      "Kamareddy",
      "Adilabad",
      "Mancherial",
      "Nirmal",
      "Kothagudem",
      "Bhadrachalam",
      "Siddipet",
      "Medak",
      "Sangareddy",
      "Zaheerabad",
      "Vikarabad",
      "Mahabubabad",
      "Jangaon",
      "Bhupalpally",
      "Wanaparthy",
      "Nagarkurnool",
      "Gadwal",
      "Narayanpet",
      "Medchal",
      "Shamirpet",
      "Chevella",
      "Tandur",
      "Peddapalli",
      "Sircilla",
      "Bhongir",
      "Yadadri",
      "Huzurnagar",
      "Kodad",
      "Devarakonda",
      "Armur",
      "Bodhan",
      "Bellampalli",
      "Asifabad",
      "Luxettipet",
      "Manuguru",
      "Palwancha",
      "Dornakal",
      "Parkal",
      "Ghatkesar",
      "Uppal",
      "LB Nagar",
      "Secunderabad"
    ], "Tripura": ["Agartala", "Udaipur", "Dharmanagar"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi", "Agra", "Noida"],
    "Uttarakhand": ["Dehradun", "Haridwar", "Nainital", "Rishikesh"],
    "West Bengal": ["Kolkata", "Howrah", "Darjeeling", "Siliguri", "Durgapur"],
    "Andaman and Nicobar Islands": ["Port Blair", "Car Nicobar"],
    "Chandigarh": ["Chandigarh"],
    "Dadra and Nagar Haveli and Daman and Diu": ["Silvassa", "Daman", "Diu"],
    "Delhi": ["New Delhi", "Dwarka", "Rohini", "Karol Bagh"],
    "Jammu and Kashmir": ["Srinagar", "Jammu", "Anantnag", "Baramulla"],
    "Ladakh": ["Leh", "Kargil"],
    "Lakshadweep": ["Kavaratti", "Agatti"],
    "Puducherry": ["Pondicherry", "Karaikal", "Mahe", "Yanam"]
  };

  return (
    <div className='mainBlock'>
      <FormAside />
      <FormNotification />
      <div className="mou-order-form">


        <style>{mouInlineStyles}</style>
        <table className="mou-print-wrapper">
          <thead>
            <tr><td>
              <img src={headerImg} alt="Header" className="mou-header-img" />
            </td></tr>
          </thead>
          <tbody>
            <tr><td>
              <div className="mou-page">
                <div className="mou-title">MEMORANDUM OF UNDERSTANDING</div>
                <p className="mou-line">
                  <span className="mou-text">
                    This Memorandum of Understanding (MOU) is made and executed on
                  </span>

                  <input
                    type="date"
                    name="executedDate"
                    value={data.executedDate}
                    onChange={handleChange}
                    className="mou-inline-input mou-date-input"
                  />

                  {" "}at{" "}

                  <select
                    name="state"
                    value={data.state}
                    onChange={(e) =>
                      setData({ ...data, state: e.target.value, city: '' })
                    }
                    className="mou-inline-input mou-stretch-field"
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </p>

                <p className="mou-line mou-second-line">
                  <select
                    name="city"
                    value={data.city}
                    onChange={handleChange}
                    className="mou-inline-input mou-city-field"
                    disabled={!data.state}
                  >
                    <option value="">Select City</option>
                    {data.state &&
                      cities[data.state].map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))
                    }
                  </select>
                </p>

                <p><strong>BETWEEN</strong></p>

                <p>
                  M/s <strong>CODENAUT PRIVATE LIMITED</strong>, having its registered office at
                  Capitol Tower, Plot No. 1, 2nd Floor, Beside N Convention, Khanamet,
                  Hitech City,<br /> Madhapur, Hyderabad, Telangana 500081, India,
                  represented by Director, hereinafter referred to as the <strong>First Party</strong>.
                </p>

                <p><strong>AND</strong></p>

                <p className="mou-stretch-line">
                  M/s{" "}
                  <span className={`mou-underline-text mou-stretch-field ${data.schoolName ? "mou-filled" : ""}`}>
                    {data.schoolName || ""}
                  </span>
                </p>

                <p className="mou-stretch-line">
                  having its office at{" "}
                  <input
                    type="text"
                    className="mou-inline-input mou-stretch-field"
                    placeholder=""
                  />
                </p>

                <p>
                  India, represented by Mr. or Ms.{" "}
                  <span className={`mou-underline-text ${data.contactPerson ? "mou-filled" : ""}`}>
                    {data.contactPerson || "________________"}
                  </span>
                  {" "}hereinafter referred to as the <strong>Second Party</strong>.
                </p>
                <p>The First party and Second Party are hereinafter individually referred to as a "Party" and collectively as the "Parties" </p>

                <h4>1. NATURE AND PURPOSE</h4>

                <p>
                  <span className='mou-page-side-points'> 1.1</span> This MoU sets out the agreed framework governing the provision, implementation, and use of a school management and communication platform by the First Party to the Second Party, along with the corresponding commercial and operational arrangements between the Parties.
                  <br /><br />
                  <span className='mou-page-side-points'> 1.2</span> The Parties acknowledge and agree that, notwithstanding its designation as a “Memorandum of Understanding”, this MoU creates legally binding obligations in respect of the services, payment terms, and other rights and responsibilities expressly set out herein.
                </p>


                <h4>2. SCOPE OF SERVICES </h4>
                <p>
                  <span className='mou-page-side-points'> 2.1</span> The First Party shall provide the Second Party with access to a web-based and mobile-enabled school management and communication platform (“Platform”), comprising integrated modules and functionalities designed to support administrative, academic, and communication processes.
                  <br /><br />
                  <span className='mou-page-side-points'> 2.2</span> The Platform shall include, but not be limited to:
                </p>

                <ol className='MOU-form-ol'>
                  <li>
                    AI-enabled administrative assistance tools;
                  </li>

                  <li>
                    Centralized data management systems;
                  </li>

                  <li>
                    Attendance monitoring, academic tracking, and reporting functionalities;
                  </li>
                  <li>
                    Communication interfaces for interaction between school management, staff, students, and other stakeholders.
                  </li>
                </ol>
                <br />
                <p><span className='mou-page-side-points'> 2.3</span> The specific configuration, features, and scale of deployment of the Platform shall be as set out in the applicable Order Form, which shall form an integral part of this MoU.
                  <br /><br />
                  <span className='mou-page-side-points'> 2.4</span>Notwithstanding anything contained in this MoU, the detailed terms and conditions governing access to, usage of, and subscription to the Platform, including but not limited to user rights, restrictions, service levels, data handling, and technical provisions, shall be set out in a separate Software-asa-Service Agreement (“SaaS Agreement”) to be executed between the Parties. In the event of any inconsistency between this MoU and the SaaS Agreement in relation to the use of the Platform, the provisions of the SaaS Agreement shall prevail to the extent of such inconsistency.
                </p>


                <h4>3. TERM AND COMMITMENT </h4>

                <p>
                  <span className='mou-page-side-points'> 3.1</span> This MoU shall come into effect on the date the Platform is deployed and made operational for use by the Second Party (“Commencement Date”).
                  <br />
                  <span className='mou-page-side-points'> 3.2</span> The Second Party agrees to a minimum, non-cancellable commitment period of two (2) years from the Commencement Date (“Initial Term”).
                  <br />
                  <span className='mou-page-side-points'> 3.3</span> Upon expiry of the Initial Term, this MoU shall automatically renew for successive periods of one (1) year each, unless either Party provides written notice of its intention not to renew at least sixty (60) days prior to the expiry of the then-current term.
                </p>

                <p>
                  The First Party shall provide a fully integrated web and mobile based school management platform.
                </p>


                <h4>4. OBLIGATIONS OF THE SECOND PARTY </h4>

                <p>The Second Party shall:
                  <br />
                  <span className='mou-page-side-points'> 4.1</span>Submit a duly completed and accurate Order Form in the prescribed format, along with the applicable payment(s), as a condition for initiation of services under this MoU.
                  <br />
                  <span className='mou-page-side-points'> 4.2</span> Provide complete, accurate, and timely data, information, and inputs required for onboarding, configuration, and operation of the Platform, and shall remain responsible for the correctness of such data.
                  <br />
                  <span className='mou-page-side-points'> 4.3</span> Use the Platform strictly in accordance with applicable laws and for legitimate institutional purposes, and shall ensure that its users (including staff and representatives) comply with such requirements.
                  <br />
                  <span className='mou-page-side-points'> 4.4</span> Not, directly or indirectly, copy, modify, reverse engineer, decompile, extract, or otherwise misuse the Platform or any part thereof, nor permit any third party to do so.
                </p>



                <h4>5. OBLIGATIONS OF THE FIRST PARTY </h4>

                <p>
                  The First Party shall:
                  <br />
                  <span className='mou-page-side-points'> 5.1</span> Provide access credentials and enable the Platform for use by the Second Party within ten (10) working days from receipt of complete and accurate data and fulfilment of initial requirements.
                  <br />
                  <span className='mou-page-side-points'> 5.2</span> Deliver and maintain a functional Platform in accordance with the agreed scope, including necessary configurations to enable its intended use by the Second Party.
                  <br />
                  <span className='mou-page-side-points'> 5.3</span> Provide reasonable onboarding assistance, including initial setup, configuration support, and training to the Second Party’s designated personnel for effective use of the Platform.
                  <br />
                  <span className='mou-page-side-points'> 5.4</span> Use commercially reasonable efforts to ensure continuity and availability of the Platform, subject to necessary maintenance, upgrades, and circumstances beyond its control.
                </p>


                <h4>6.  IMPLEMENTATION AND ACCEPTANCE </h4>
                <p>
                  <span className='mou-page-side-points'> 6.1</span> The Platform shall be deemed implemented upon deployment and activation for use by the Second Party.
                  <br />
                  <span className='mou-page-side-points'> 6.2</span> The Second Party shall review the Platform within seven (7) days from the date of deployment and notify the First Party in writing of any material deficiencies that prevent the Platform from functioning in accordance with the agreed scope. <br />
                  <span className='mou-page-side-points'> 6.3</span> In the absence of such written notification within the specified period, the Platform shall be deemed to have been accepted by the Second Party. <br />
                  <span className='mou-page-side-points'> 6.4</span> Upon receipt of any valid deficiency notice, the First Party shall use commercially reasonable efforts to rectify such deficiencies within a reasonable time.
                </p>

                <h4>7. FEES AND PAYMENT TERMS </h4>
                <h5>7.1 Initial Payment </h5>
                <p>
                  The Second Party shall pay an advance amount equivalent to fifty percent (50%) of the applicable student login charges, calculated based on the estimated student strength, as a condition for initiation of services under this MoU.
                </p>
                <h5>7.2 Billing </h5>
                <ol className='MOU-form-ol'>
                  <li>The services shall be billed on an annual basis. </li>
                  <li>The first invoice shall be raised upon deployment of the Platform. </li>
                  <li>The fees shall be subject to an annual escalation of five percent (5%) commencing after completion of the initial two (2) years. </li>
                </ol>
                <h5>7.3 Payment Timeline </h5>
                <p>All invoices shall be payable within seven (7) days from the date of issuance, without any deduction, withholding, or set-off, unless otherwise mutually agreed in writing.

                </p>
                <h5> 7.4 Consequences of Delayed Payment </h5>
                <ol className='MOU-form-ol'>
                  <li>
                    Any delay in payment shall attract interest at the rate of eighteen percent (18%) per annum, calculated on a pro-rata basis for the period of delay.
                  </li>
                  <li>
                    In the event of non-payment beyond the due date, the First Party shall have the right, upon written notice, to suspend access to the Platform until such payment is received, without prejudice to its other rights under this MoU.
                  </li>
                </ol>

                <h4>STUDENT STRENGTH ADJUSTMENT</h4>
                <p>
                  <span className='mou-page-side-points'> 8.1</span> The student strength of the Second Party shall be reviewed on an annual basis at the time of renewal or as otherwise agreed between the Parties. <br />
                  <span className='mou-page-side-points'> 8.2</span> Any increase or decrease in student strength shall be reflected in the billing for the subsequent billing cycle, based on the applicable per-student pricing. <br />
                  <span className='mou-page-side-points'> 8.3</span> The Second Party shall provide accurate and updated student data for such review, and any material discrepancy identified may be adjusted prospectively in billing.
                </p>
                <h4>
                  9.INTELLECTUAL PROPERTY
                </h4>
                <p>
                  <span className='mou-page-side-points'> 9.1</span> The Platform, including its software, design, architecture, features, documentation, and all associated intellectual property rights, shall remain the sole and exclusive property of the First Party. <br />
                  <span className='mou-page-side-points'> 9.2</span> Subject to compliance with the terms of this MoU, the First Party grants to the Second Party a limited, non-exclusive, non-transferable, and revocable right to access and use the Platform solely for its internal institutional purposes during the term of this MoU. <br />
                  <span className='mou-page-side-points'> 9.3</span> The Second Party shall not acquire any ownership, title, or interest in the Platform or any part thereof, and shall not remove, alter, or obscure any proprietary notices or markings.
                  <br />
                  <span className='mou-page-side-points'> 9.4</span> The Second Party shall not undertake, publish, or disseminate any marketing, promotional, or branding activities, materials, communications, or representations relating to the Platform or the First Party, including use of the First Party’s name, trademarks, logos, or brand assets, without the prior written review and approval of the First Party. The First Party shall have the right to review, modify, or withhold approval of any such materials at its sole discretion to ensure consistency with its brand guidelines and positioning.
                </p>
                <h4>
                  10. DATA PROTECTION
                </h4>
                <p>
                  <span className='mou-page-side-points'> 10.1</span> All data, information, and records provided or generated by the Second Party through use of the Platform (“Client Data”) shall remain the property of the Second Party.
                  <br />
                  <span className='mou-page-side-points'> 10.2</span> The First Party shall implement commercially reasonable technical and organizational measures to protect Client Data against unauthorized access, use, alteration, or disclosure. <br />
                  <span className='mou-page-side-points'> 10.3</span> The First Party shall process and use Client Data solely for the purpose of providing and improving the services under this MoU and shall not disclose such data to any third party without the prior written consent of the Second Party, except where required by applicable law or lawful authority. <br />
                  <span className='mou-page-side-points'> 10.4</span> Each Party shall comply with applicable data protection and privacy laws in relation to its respective obligations under this MoU.
                </p>
                <h4>11. CONFIDENTIALITY </h4>
                <p> <span className='mou-page-side-points'> 11.1</span> Each Party agrees to keep confidential and not disclose to any third party any non-public, proprietary, technical, commercial, or financial information received from the other Party in connection with this MoU (“Confidential Information”), except as required for the performance of its obligations under this MoU or as required by law. <br />
                  <span className='mou-page-side-points'> 11.2</span> Each Party shall use the Confidential Information solely for the purposes of this MoU and shall take reasonable measures to protect such information from unauthorized access, use, or disclosure. <br />
                  <span className='mou-page-side-points'> 11.3</span> Confidential Information may be disclosed to a Party’s employees, advisors, or representatives on a need-to-know basis, provided such persons are bound by confidentiality obligations of a similar nature.
                  <br /> <span className='mou-page-side-points'> 11.4</span> The obligations under this Clause shall not apply to information that is publicly available without breach, lawfully obtained from a third party, or independently developed without reference to the Confidential Information.
                  <br /> <span className='mou-page-side-points'> 11.5</span> The obligations of confidentiality shall survive termination of this MoU for a period of three (3) years.
                </p>
                <h4>
                  12. LIMITATION OF LIABILITY
                </h4>
                <p> <span className='mou-page-side-points'> 12.1</span> To the fullest extent permitted under applicable law, neither Party shall be liable to the other for any indirect, incidental, consequential, special, or punitive damages, including loss of profits, loss of data, or loss of business opportunity, arising out of or in connection with this MoU. <br />
                   <span className='mou-page-side-points'> 12.2</span> Each Party’s total aggregate liability arising out of or in connection with this MoU shall be limited to the actual direct damages proven and shall not exceed the total fees paid by the Second Party to the First Party under this MoU during the twelve (12) months immediately preceding the event giving rise to the claim. <br />
                   <span className='mou-page-side-points'> 12.3</span> The limitations set out in this Clause shall not apply to:
                  <ol className='MOU-form-ol'>
                    <li>breach of confidentiality obligations under Clause 11; </li>
                    <li>breach of intellectual property rights under Clause 9; </li>
                    <li>fraud, wilful misconduct, or gross negligence; or </li>
                    <li>any liability which cannot be limited or excluded under applicable law. </li>
                  </ol>
                </p>
                <h4>13. TERMINATION </h4>
                <h5>13.1 Termination for Convenience </h5>
                <p>Either Party may terminate this MoU without cause by providing not less than sixty (60) days’ prior written notice to the other Party. </p>
                <h5>13.2 Minimum Commitment Protection </h5>
                <p>Notwithstanding Clause 13.1, if the Second Party terminates this MoU prior to completion of the Initial Term specified in Clause 3, the Second Party shall remain liable to pay the balance subscription fees for the remainder of the Initial Term, which shall become immediately due and payable upon such termination. </p>
                <h5>13.3 Termination for Cause </h5>
                <p>Either Party may terminate this MoU with immediate effect by written notice if the other Party: </p>
                <ol className='MOU-form-ol'>
                  <li>
                    commits a material breach of this MoU and fails to cure such breach within fifteen (15) days of receiving written notice;
                  </li>
                  <li>fails to make payment in accordance with Clause 7; or </li>
                  <li>engages in misuse, unauthorized use, or conduct that materially affects the integrity or security of the Platform. </li>
                </ol>
                <h5>13.4 Effect of Termination </h5>
                <p>Upon termination or expiry of this MoU:
                  <ol className='MOU-form-ol'><li>the Second Party’s right to access and use the Platform shall cease; </li>
                    <li>all outstanding payments shall become immediately due and payable; and </li>
                    <li>he provisions which by their nature are intended to survive shall continue in effect. </li>
                  </ol> </p>
                <h4>FORCE MAJEURE </h4>
                <p> <span className='mou-page-side-points'> 14.1</span> Neither Party shall be liable for any failure or delay in the performance of its obligations under this MoU (other than payment obligations) to the extent such failure or delay is caused by events beyond its reasonable control (“Force Majeure Event”), including but not limited to natural disasters, acts of God, war, civil unrest, governmental actions, epidemics, pandemics, or disruptions to essential infrastructure.
                  <br />
                   <span className='mou-page-side-points'> 14.2</span> The affected Party shall promptly notify the other Party in writing of the occurrence of a Force Majeure Event, along with reasonable details of its nature, expected duration, and impact, and shall use commercially reasonable efforts to mitigate the effects and resume performance as soon as practicable. <br />
                   <span className='mou-page-side-points'> 14.3</span> If a Force Majeure Event continues for a period exceeding thirty (30) consecutive days and materially affects performance under this MoU, the Parties shall discuss in good faith appropriate modifications, suspension, or termination of the affected obligations. <br />
                   <span className='mou-page-side-points'> 14.4</span> The occurrence of a Force Majeure Event shall not affect obligations accrued prior to such event, nor shall it excuse obligations that are not impacted by such event.
                </p>
                <h4>15. DISPUTE RESOLUTION </h4>
                <p> <span className='mou-page-side-points'> 15.1</span> The Parties shall, in the first instance, attempt to resolve any dispute, controversy, or claim arising out of or in connection with this MoU through good faith discussions between their respective authorized representatives. <br />
                   <span className='mou-page-side-points'> 15.2</span> If the dispute is not resolved within thirty (30) days from the commencement of such discussions, the same shall be referred to and finally resolved by arbitration in accordance with the provisions of the Arbitration and Conciliation Act, 1996 (as amended from time to time). <br />
                  <span className='mou-page-side-points'> 15.3</span> The arbitration shall be conducted by a sole arbitrator mutually appointed by the Parties. In the event the Parties fail to agree on the appointment of the arbitrator, the arbitrator shall be appointed in accordance with the provisions of the Arbitration and Conciliation Act, 1996.
                 <span className='mou-page-side-points'> 15.4</span> The seat and venue of arbitration shall be Hyderabad, India, and the arbitration proceedings shall be conducted in the English language. <br />
                 <span className='mou-page-side-points'> 15.5</span> The arbitral award shall be final and binding on the Parties. Each Party shall bear its own costs, unless otherwise determined by the arbitrator.

                </p>
                <h4>
                  16. GOVERNING LAW
                </h4>
                <p><span className='mou-page-side-points'> 16.1</span> This MoU shall be governed by and construed in accordance with the laws of India, without regard to its conflict of laws principles.
                  <br />
                  <span className='mou-page-side-points'> 16.2</span> Subject to Clause 15 (Dispute Resolution), the courts at Hyderabad, India shall have exclusive jurisdiction in respect of any matters requiring judicial intervention, including interim or injunctive relief.
                </p>
                <h4>17. GENERAL PROVISIONS </h4>
                <h5>17.1 Entire Agreement </h5>
                <p>This MoU constitutes the entire understanding between the Parties with respect to its subject matter and supersedes all prior discussions, negotiations, representations, or arrangements, whether written or oral. </p>
                <h5>17.2 Amendments </h5>
                <p>No amendment, modification, or waiver of any provision of this MoU shall be valid unless made in writing and duly executed by both Parties. </p>
                <h5>

                  17.3 Assignment
                </h5>
                <p>Neither Party shall assign, transfer, or delegate its rights or obligations under this MoU, in whole or in part, without the prior written consent of the other Party, such consent not to be unreasonably withheld or delayed. </p>
                <h5>
                  17.4 Severability
                </h5>
                <p>If any provision of this MoU is held to be invalid, illegal, or unenforceable by a competent authority, the remaining provisions shall continue in full force and effect, and the Parties shall in good faith replace the affected provision with a valid provision that most closely reflects the original intent. </p>
                <h4>18. ORDER FORM </h4>
                <p>
                  <span className='mou-page-side-points'> 18.1</span> The Order Form executed between the Parties shall form an integral and binding part of this MoU and shall set out the specific commercial, operational, and deployment details agreed between the Parties, including but not limited to pricing, student strength, and configuration requirements. <br />
                  <span className='mou-page-side-points'> 18.2</span> In the event of any inconsistency between the terms of this MoU and the Order Form, the provisions of this MoU shall prevail, unless expressly stated otherwise in the Order Form.
                </p>
                <h4>19. SIGNATURES </h4>
                <p>IN WITNESS WHEREOF, the Parties have executed this MoU on the date first mentioned above. </p>

                <div className='signature-and-seal'>
                  <div className='signature-and-seal-left'>
                    <h4>(Seal & Signature)<br /><span>For</span> CODENAUT PVT LTD</h4>
                    <div className='sas-left-top'>
                      <p>Name: <br />
                        Title:<br />
                        Date:</p>
                    </div>
                    <h5>WITNESS: </h5>
                    <div className='sas-left-bottom'>
                      <p>Name:</p><p>Signature:</p>
                    </div>
                  </div>
                  <div className='signature-and-seal-right'>
                    <p>
                      <canvas
                        ref={signatureRef}
                        width={300}
                        height={80}
                        className="mou-signature-canvas"
                        onMouseDown={startDraw}
                        onMouseMove={draw}
                        onMouseUp={endDraw}
                        onMouseLeave={endDraw}
                      />

                    </p>
                    <h4>(Seal & Signature)<br /><span>For</span> CLIENT
                    </h4>
                    <div className='sas-right-top'>
                      <p>Name:<br />
                        Title:<br />
                        Date:</p>
                    </div>
                    <h5>WITNESS: </h5>
                    <div className='sas-right-bottom'>
                      <p>Name:</p><p>Signature:
                        {
                          data.signature ? (<img
                            src={signatureUrl}
                            alt="Signature"
                            className="mou-signature-canvas"
                            style={{
                              width: "300px",
                              height: "80px",
                              objectFit: "contain"
                            }} />) :
                            (<>
                              <canvas
                                ref={signatureRef}
                                width={300}
                                height={80}
                                className="mou-signature-canvas"
                                onMouseDown={startDraw}
                                onMouseMove={draw}
                                onMouseUp={endDraw}
                                onMouseLeave={endDraw}
                              />
                            </>)}

                        <button
                          className="mou-submit-btn"
                          type="button"
                          onClick={clearSignature}
                        >
                          Clear
                        </button></p>
                    </div>
                    <div className="mou-submit-container">
                      {/* <div className="mou-left-actions">
                        <label className="mou-upload-btn">
                          Upload File
                          <input
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                            hidden
                            onChange={handleFileUpload}
                          />
                        </label>
                      </div> */}
                      <button className="mou-submit-btn" onClick={handleOpenSubmitPreview}>
                        Submit
                      </button>

                    </div>
                  </div>

                </div>


                <div className='updatedOrderForm'>
                  <h4>ORDER FORM </h4>
                  <br /><br />
                  <label>CONTACT PERSON NAME: </label><br />
                  <input name="contactPerson" value={data.contactPerson} onChange={handleChange} /><br />
                  <label>SCHOOL/INSTITUTION NAME: </label><br />
                  <input name="schoolName" value={data.schoolName} onChange={handleChange} /><br />
                  <label>ADDRESS:</label><br />
                  <input name="address" value={branchData.address} onChange={handleBranchChange} /><br />
                  <label>PHONE NO: </label><br />
                  <input name="phone" value={data.phone} autoComplete='off' onChange={handleChange} /><br />
                  <label>EMAIL ID:</label><br />
                  <input name="email" value={data.email} onChange={handleChange} /><br />
                  <label>NUMBER OF STUDENTS: </label><br />
                  <input
                    type="number"
                    name="strength"
                    value={data.strength}
                    onChange={handleChange}
                  /><br />
                  <label>AMOUNT:</label><br />
                  <input
                    type="number"
                    name="amountPerStudent"
                    value={data.amountPerStudent}
                    onChange={handleChange}
                    className="mou-no-spin"
                  />
                  <br />

                  <label>NUMBER OF TEACHING STAFF: </label><br />
                  <input type="number" name='teachingStaff' onChange={handleChange}  className='mou-no-spin'/><br />
                  <label>NUMBER OF NON-TEACHING STAFF (INCLUDING MANAGEMENT): </label><br />
                  <input type="number" name='nonTeachingStaff' onChange={handleChange} />

                </div>


                <table>
                  <tbody>
                    <tr>
                      <td>Total Amount</td>
                      <td>
                        <input
                          type="text"
                          readOnly
                          value={`${data.strength || 0} students × ${data.amountPerStudent || 0} = ${data.totalAmount || 0}`}
                          className="mou-total-amount-input"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Advance Amount</td>
                      <td>
                        <input
                          name="advanceAmount"
                          value={data.advanceAmount}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Balance Amount</td>
                      <td>
                        <input
                          name="balanceAmount"
                          value={data.balanceAmount}
                          readOnly // User cannot edit manually
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Advance Paid Date</td>
                      <td>
                        <input
                          type="date"
                          name="advancePaidDate"
                          value={data.advancePaidDate || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>Balance Paid Date</td>
                      <td>
                        <input
                          type="date"
                          name="balancePaidDate"
                          value={data.balancePaidDate || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="mou-bank-details">

                  <p>Payments may be made to:</p>

                  <p>
                    <strong>Account Name:</strong>  Codenaut Private Limited <br />
                    <strong>Account Number:</strong> 126520800000286<br />
                    <strong>IFSC Code:</strong>  YESB0001265 <br />
                    <strong>Bank Branch:</strong> Shaikpet, Hyderabad
                  </p>

                  <p>
                    Alternatively, payment may be made via <span> UPI using the provided QR code.
                    </span>
                  </p>

                </div>
                <div className="mou-qr-box">
                  <div className="mou-scan-text">SCAN & PAY</div>

                  <img src={qrImg} alt="QR Code" className="mou-qr-image" />

                  <div className="mou-upi-text">
                    UPI ID: <span>yespay.mabs1265208wkito286@yesbank</span>
                  </div>
                </div>
              </div>
            </td></tr>
          </tbody>
          <tfoot>
            <tr><td>
              <img src={footerImg} alt="Footer" className="mou-footer-img" />
            </td></tr>
          </tfoot>
        </table>

        {showSubmitPreview && (
          <div
            className="mou-popup-overlay"
            onClick={() => setShowSubmitPreview(false)}
          >
            <div
              className="mou-popup-box"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Review Details</h3>
              <p>Please check the details below before submitting.</p>

              <div className="mou-confirm-grid">
                <div className="mou-confirm-item">
                  <span>School Name</span>
                  <strong>{data.schoolName || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Contact Person</span>
                  <strong>{data.contactPerson || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Designation</span>
                  <strong>{data.designation || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Email</span>
                  <strong>{data.email || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Phone</span>
                  <strong>{data.phone || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Strength</span>
                  <strong>{data.strength || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Total Amount</span>
                  <strong>{data.totalAmount || '-'}</strong>
                </div>
                <div className="mou-confirm-item">
                  <span>Balance Amount</span>
                  <strong>{data.balanceAmount || '-'}</strong>
                </div>
              </div>

              <div className="mou-confirm-item" style={{ marginTop: '12px' }}>
                <span>Address</span>
                <strong>{data.address || '-'}</strong>
              </div>

              <div className="mou-confirm-item" style={{ marginTop: '12px' }}>
                <span>Payment Dates</span>
                <strong>
                  Advance: {data.advancePaidDate || '-'} | Balance: {data.balancePaidDate || '-'}
                </strong>
              </div>

              <div className="mou-confirm-list">
                <h4>Branches</h4>
                {branches.length > 0 ? (
                  <ul>
                    {branches.map((branch, index) => (
                      <li key={`${branch.branchName || 'branch'}-${index}`}>
                        {branch.branchName || 'Branch'}
                        {branch.strength ? ` - ${branch.strength}` : ''}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div>No branches added.</div>
                )}
              </div>

              <div className="mou-confirm-actions">
                <button
                  type="button"
                  className="mou-confirm-cancel"
                  onClick={() => setShowSubmitPreview(false)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className="mou-confirm-submit"
                  onClick={handleConfirmSubmit}
                >
                  Confirm Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
